import {AddressInfo, AddressExtend} from 'types/geo';

export const formatAddressInfoToRequest = (info: AddressInfo): AddressExtend => {
    const gps = Object.values(info.location).join(',');
    const address = info.formattedAddress;
    const country = info.addressComponents.find((item) => item.kind === 'country')?.name || '';
    const city = info.addressComponents.find((item) => item.kind === 'locality')?.name || '';

    return {gps, address, country, city};
};
